import { useEffect, useState } from "react";

export default function Contact() {
  const [step, setStep] = useState(1);

  // Detectar cuando JotForm termina la submission
  useEffect(() => {
    const handler = (e) => {
      if (
        typeof e.origin === "string" &&
        e.origin.includes("jotform.com") &&
        e.data?.action === "submission-completed"
      ) {
        setStep(2);
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  // El widget de Calendly se auto-inicializa cuando detecta el div
  // .calendly-inline-widget en el DOM. Solo necesitamos hacer scroll
  // al área correspondiente cuando se monta el paso 2.
  useEffect(() => {
    if (step !== 2) return;
    const t = setTimeout(() => {
      document
        .getElementById("calendly-section")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 500);
    return () => clearTimeout(t);
  }, [step]);

  return (
    <>
    <section
      id="contacto"
      style={{
        position: "relative",
        zIndex: 2,
        padding: "100px 28px 140px",
        background: "transparent",
      }}
    >
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>
            Contacto
          </div>
          <h2
            className="font-display"
            style={{
              fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
              fontWeight: 500,
              letterSpacing: "-0.02em",
              lineHeight: 1.04,
              margin: "0 0 16px",
            }}
          >
            ¿Listo para construir con{" "}
            <em style={{ fontStyle: "italic", fontWeight: 400 }}>
              IA real?
            </em>
          </h2>
          <p
            style={{
              fontSize: 16,
              color: "var(--ink-dim)",
              maxWidth: 480,
              margin: "0 auto",
            }}
          >
            {step === 1
              ? "Cuéntame sobre tu negocio y lo que necesitas."
              : "¡Perfecto! Ahora elige fecha y hora para nuestra llamada."}
          </p>
        </div>

        {/* Indicador de pasos */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            marginBottom: 40,
          }}
        >
          <StepBadge active={step === 1} number="1" label="Tu información" />
          <div
            style={{
              width: 40,
              height: 1,
              background: "var(--line)",
            }}
          />
          <StepBadge active={step === 2} number="2" label="Agenda tu llamada" />
        </div>

        {/* PASO 1 — JotForm embebido */}
        {step === 1 && (
          <div
            style={{
              borderRadius: 18,
              overflow: "hidden",
              border: "1px solid var(--line)",
              background: "rgba(255,255,255,0.45)",
            }}
          >
            <iframe
              id="JotFormIFrame-261178049334055"
              title="Contacto SoyPacoIA"
              src="https://form.jotform.com/261178049334055"
              style={{
                width: "100%",
                height: 700,
                border: "none",
                display: "block",
              }}
              allow="geolocation; microphone; camera"
            />
          </div>
        )}

        {/* PASO 2 — Calendly inline (script inyectado dinámicamente) */}
        {step === 2 && (
          <div id="calendly-section">
            <CalendlyEmbed url="https://calendly.com/soypacoia" />
          </div>
        )}

      </div>
    </section>

    {/* Telegram flotante */}
    <a
      href="https://t.me/soypacoia"
      target="_blank"
      rel="noreferrer"
      aria-label="Contactar por Telegram"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 50,
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 20px",
        background: "#229ED9",
        color: "#fff",
        borderRadius: 100,
        fontSize: 13,
        fontWeight: 600,
        fontFamily: '"DM Sans", sans-serif',
        textDecoration: "none",
        boxShadow: "0 14px 30px rgba(34,158,217,0.4)",
        transition: "transform 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden
      >
        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L8.32 13.617l-2.96-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.828.942z" />
      </svg>
      Telegram
    </a>
    </>
  );
}

function StepBadge({ active, number, label }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 13,
        fontWeight: active ? 600 : 400,
        color: active ? "var(--ink)" : "var(--ink-dim)",
      }}
    >
      <span
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          background: active ? "var(--ink)" : "var(--line)",
          color: active ? "var(--white)" : "var(--ink-dim)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        {number}
      </span>
      {label}
    </div>
  );
}

function CalendlyEmbed({ url }) {
  // El iframe directo de Calendly no requiere script ni CSS externo.
  // Calendly sirve la página completa de booking en cualquier URL.
  return (
    <iframe
      title="Agenda con Paco"
      src={url}
      style={{
        width: "100%",
        minWidth: 320,
        height: 700,
        border: "1px solid var(--line)",
        borderRadius: 18,
        background: "rgba(255,255,255,0.45)",
        display: "block",
      }}
    />
  );
}
